import React from 'react';
import { Section } from './ui/Section';
import { Sparkles } from 'lucide-react';
export function SolutionSection() {
  return <Section background="rose" className="text-center" data-id="element-147">
      <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white shadow-sm text-rose-600 font-semibold text-sm mb-6" data-id="element-148">
        <Sparkles className="h-4 w-4" data-id="element-149" />
        La Solución Clara y Práctica
      </div>

      <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-150">
        Imagina tener el guion exacto para cada situación difícil
      </h2>

      <p className="text-lg text-gray-700 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-151">
        <span className="font-bold text-rose-700" data-id="element-152">Di Esto, No Aquello™</span>{' '}
        no es un libro de teoría aburrida. Es tu manual de emergencia con más de
        50 scripts reales que puedes usar hoy mismo.
      </p>

      <div className="grid gap-6 md:grid-cols-2 text-left max-w-3xl mx-auto" data-id="element-153">
        <div className="bg-white p-6 rounded-xl shadow-sm border border-rose-100" data-id="element-154">
          <h3 className="font-bold text-gray-900 mb-2" data-id="element-155">
            Qué decir y qué no decir
          </h3>
          <p className="text-gray-600" data-id="element-156">
            Ejemplos claros de frases que destruyen la conexión vs. frases que
            construyen puentes inmediatos.
          </p>
        </div>
        <div className="bg-white p-6 rounded-xl shadow-sm border border-rose-100" data-id="element-157">
          <h3 className="font-bold text-gray-900 mb-2" data-id="element-158">
            Funciona por texto y en persona
          </h3>
          <p className="text-gray-600" data-id="element-159">
            Ya sea por WhatsApp o cara a cara, tendrás las palabras justas para
            mantener la calma y el control.
          </p>
        </div>
        <div className="bg-white p-6 rounded-xl shadow-sm border border-rose-100" data-id="element-160">
          <h3 className="font-bold text-gray-900 mb-2" data-id="element-161">
            Lectura rápida y al grano
          </h3>
          <p className="text-gray-600" data-id="element-162">
            Diseñado para mujeres ocupadas. Sin relleno. Solo estrategias que
            puedes aplicar en 5 minutos.
          </p>
        </div>
        <div className="bg-white p-6 rounded-xl shadow-sm border border-rose-100" data-id="element-163">
          <h3 className="font-bold text-gray-900 mb-2" data-id="element-164">
            Resultados desde el primer día
          </h3>
          <p className="text-gray-600" data-id="element-165">
            Verás cómo cambia la reacción de tu pareja simplemente cambiando la
            forma en que inicias la charla.
          </p>
        </div>
      </div>
    </Section>;
}